import { createReducer, on } from '@ngrx/store';
import { appLauncherSuccess} from './appLauncher.actions';
import { AppLauncherInfo } from './appLauncher.model';

export type AppLauncherState = AppLauncherInfo;

export const initialState: AppLauncherState = {
  user: '',
  equipment_code: '',
  api_key: '',
  isPunchOut: false,
  wasSuccess: false,
};

export const appLauncherReducer = createReducer(
  initialState,
  on(appLauncherSuccess, (state, { user, equipment_code, api_key, isPunchOut,wasSuccess }) => ({
    ...state,
    user,
    equipment_code,
    api_key,
    isPunchOut,
    wasSuccess,
  }))
);